import { useTranslation } from 'react-i18next';
import { CardPocket } from '@/common/components/CardPocket/CardPocket';
import { Icon } from '@/common/components/Icons/Icon';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { Href, useRouter } from 'expo-router';

export type PTMealCardPocketProps = {
  route: Href;
};

export function PTMealCardPocket({ route }: PTMealCardPocketProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const { mealPocket, isInitialLoading: isLoadingPocket } = useGetPockets();

  return (
    <CardPocket
      title={t('dashboard.meal_home.balance.title')}
      icon={<Icon icon="utensils" />}
      values={[
        {
          value: MoneyUtils.moneyToString(mealPocket?.balance),
          loading: isLoadingPocket,
        },
      ]}
      onPress={() => router.push(route)}
    />
  );
}
